// extracted by mini-css-extract-plugin
export default {"loginForm":"login_loginForm__YJD89","spaceBetween":"login_spaceBetween__bgqVX","forgotPassword":"login_forgotPassword__yQezj","loginBtn":"login_loginBtn__Lucbf"};